let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eSmA4")).then(() => parcelRequire('1LQwL'));